export const parseChildAccountNames = (inputString: string): string[] => {
  return inputString
    .split('\n')
    .filter((name) => name.trim() !== '') // this will filter out any empty or whitespace-only strings
    .map((name) => name.trim()); // trim any extra whitespace from the names
};
